import styled from 'styled-components'

const CardHeading = styled.h3`
  width: 100%;
  font-weight: 600;
  font-size: 1.25em;
  line-height: 20px;
  letter-spacing: -0.177778px;
  color: ${props => props.theme.colors.black500};
  margin-bottom: 0;
  padding-bottom: 6px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`

export default CardHeading
